'use strict';

import React, {Component} from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Error extends Component {

    render() {
        return (
            <div className="app-wrapper maintenance-mode">
                <header role="banner">
                    <div className="app-header-container">
                        <div className="app-header d-flex bg-purple">
                            <a href="https://uw.edu" title="University of Washington Home">
                                <div className="uw-patch">University of Washington</div>
                                <div className="uw-wordmark">University of Washington</div>
                            </a>
                        </div>
                    </div>
                </header>
                <Container fluid className="bg-white">
                    <Row>
                        <Col className="p-5">
                            <main role="main" className="content pb-0 d-flex flex-column flex-md-row" id="main-content">
                                <div className="me-5" style={{maxWidth: "28rem"}}>
                                    <h1 className="display-5 mb-4">Unable to Load Page</h1>
                                    <h2 className="h3 text-uppercase mb-4">A server error has occurred</h2>

                                    <p>MyPlan is experiencing an issue with our service provider.</p>
                                    <p>If you are trying to register or complete another critical task please go to the <a
                                            href="https://sdb.admin.uw.edu/students/uwnetid/register.asp" target="_blank"> Student Personal Services webpages</a>.
                                    </p>
                                    <p>Contact <a href="mailto:help@uw.edu">help@uw.edu</a> with any questions.</p>

                                    <ul>
                                        <li><a href="https://sdb.admin.uw.edu/students/uwnetid/register.asp" target="_blank">Registration</a></li>
                                        <li><a href="https://www.washington.edu/students/timeschd/" target="_blank">Time Schedule</a></li>
                                        <li><a href="https://my.uw.edu/" target="_blank">MyUW</a></li>
                                        <li><a href="https://itconnect.uw.edu/help/servicestatus/" target="_blank">Service Status</a></li>
                                        <li><a href="https://eoutage.uw.edu/" target="_blank">UW IT eOutage</a></li>
                                        <li><a href="https://itconnect.uw.edu/tools-services-support/academic-planning/myplan-academic-planner/known-issues/" target="_blank">MyPlan Known Issues</a></li>
                                    </ul>
                                </div>
                                <div className="flex-fill husky-dog" />
                            </main>
                        </Col>
                    </Row>
                </Container>
                <footer className="container-fluid p-3 fs-7 bg-navigate border border-3 border-start-0 border-end-0 border-bottom-0">
                    <div className="d-md-flex align-items-md-start justify-content-md-between">
                        <div className="text-center text-md-start">
                            <ul className="list-inline list-inline-pipe-separated mb-0">
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/it-connect-home/question/" target="_blank">UW-IT Help</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://itconnect.uw.edu/" target="_blank">IT Connect</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://www.washington.edu/online/privacy" target="_blank">Privacy</a>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <a href="https://www.washington.edu/online/terms" target="_blank">Terms</a>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center text-md-end mt-4 mt-md-0">
                            <ul className="list-inline list-inline-pipe-separated mb-0">
                                <li className="list-inline-item mb-2 mb-md-0">&copy; {new Date().getFullYear()} <a href="https://www.washington.edu/" target="_blank">University of Washington</a></li>
                                <li className="list-inline-item mb-2 mb-md-0">Seattle, WA</li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Error;
